<template>
  <div class="search-template" theme>
    <div id="search-header" />
    <div id="search-leftside" />
    <div id="search-content" />
    <div id="search-rightside" />
    <div id="search-footer" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'search',
      parts: [
        {
          elem: '#search-header',
          htmlFile: 'header'
        },
        {
          elem: '#search-leftside',
          htmlFile: 'leftside'
        },
        {
          elem: '#search-content',
          htmlFile: 'content'
        },
        {
          elem: '#search-rightside',
          htmlFile: 'rightside'
        },
        {
          elem: '#search-footer',
          htmlFile: 'footer'
        }
      ]
    }
  }
}
</script>

<style scoped>
.search-template {
  min-height: 100px;
  margin-top: -35px;
}
</style>
